import client from './client'

export interface LoginRequest { email: string; password: string }
export interface TokenResponse { accessToken: string; refreshToken: string; expiresInSec: number }
export interface Me { email: string; role: string }

export const TOKEN_KEY = 'romset.token'
export const REFRESH_KEY = 'romset.refresh'

export const authApi = {
  login: (req: LoginRequest) =>
    client.post<TokenResponse>('/auth/login', req).then((r) => r.data),
  refresh: (refreshToken: string) =>
    client.post<TokenResponse>('/auth/refresh', { refreshToken }).then((r) => r.data),
  me: () => client.get<Me>('/auth/me').then((r) => r.data),
}

export function saveTokens(t: TokenResponse) {
  localStorage.setItem(TOKEN_KEY, t.accessToken)
  localStorage.setItem(REFRESH_KEY, t.refreshToken)
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_KEY)
}

export function isLoggedIn(): boolean {
  return !!localStorage.getItem(TOKEN_KEY)
}
